import { QueryType } from '@/app/types/types'
import axios from 'axios'

const createJobDescriptionRequest = async (data: QueryType) => {
    const response = await axios.post('/api/jd', data)
    return response
}

const getAllJobDescriptionsRequest = async (query: QueryType) => {
    const response = await axios.get('/api/jd', { params: query })
    return response
}

const updateJobDescriptionRequest = async (id: string, data: QueryType) => {
    const response = await axios.patch(`/api/jd/${id}`, data)
    return response
}

const deleteJobDescriptionRequest = async (id: string, data: QueryType) => {
    const response = await axios.delete(`/api/jd/${id}`, { params: data })
    return response
}

const getOneJobDescriptionRequest = async (id: string, params: QueryType) => {
    const response = await axios.get(`/api/jd/${id}`, { params })
    return response
}

export { createJobDescriptionRequest, getAllJobDescriptionsRequest, updateJobDescriptionRequest, deleteJobDescriptionRequest, getOneJobDescriptionRequest }
